import { render, staticRenderFns } from "./DevelopStatistic.vue?vue&type=template&id=39e40022&scoped=true"
import script from "./DevelopStatistic.vue?vue&type=script&lang=js"
export * from "./DevelopStatistic.vue?vue&type=script&lang=js"
import style0 from "./DevelopStatistic.vue?vue&type=style&index=0&id=39e40022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e40022",
  null
  
)

export default component.exports